export const LONG_FORM_SECTION_TEXT_STATUS = {
  improved: 'improved',
  keptTheSame: 'kept_the_same',
  edited: 'edited',
  accepted: 'accepted',
  previouslyAccepted: 'previously_accepted',
  doneWithErrors: 'done_with_errors', // should be treated as `kept_the_same` for now - means that there were errors during section content generation, and it was not improved
};

/**
 * Check if section was already "accepted" in the past
 * @param {Object} section
 * @returns {boolean}
 */
export const longFormSectionWasAlreadyAccepted = (section) => {
  return [
    LONG_FORM_SECTION_TEXT_STATUS.accepted,
    LONG_FORM_SECTION_TEXT_STATUS.previouslyAccepted,
  ].includes(section?.textStatus);
};

/**
 * Check if section is newly generated and was not edited/accepted yet
 * @param {Object} section
 * @returns {boolean}
 */
export const longFormSectionIsNewlyGenerated = (section) => {
  return (
    section?.textStatus === LONG_FORM_SECTION_TEXT_STATUS.improved ||
    longFormSectionTextStatusKeptTheSame(section?.textStatus)
  );
};

/**
 * Check if section text status is "kept the same"
 * @param {LONG_FORM_SECTION_TEXT_STATUS} textStatus
 * @returns {boolean}
 */
export const longFormSectionTextStatusKeptTheSame = (textStatus) => {
  return [
    LONG_FORM_SECTION_TEXT_STATUS.keptTheSame,
    LONG_FORM_SECTION_TEXT_STATUS.doneWithErrors,
  ].includes(textStatus);
};
